import { type IconProps, type TextProps } from '@backyard-ui/core';

import { type Price } from '@/infra/services/catalog/model';

interface BuildTextColorsProps {
  isOutlet: boolean;
  isOffer: boolean;
}

export function buildTextColors(props: Readonly<BuildTextColorsProps>): {
  toPrice: TextProps['color'];
  promotionalPrice?: TextProps['color'];
  percentage?: TextProps['color'];
  priceLabel: TextProps['color'];
  stripTitle?: TextProps['color'];
  priceSuffix: TextProps['color'];
  dfpPrice?: TextProps['color'];
  infoButton?: IconProps['color'];
  installments?: TextProps['color'];
} {
  const { isOutlet, isOffer } = props;

  if (isOffer) {
    if (isOutlet) {
      return {
        toPrice: 'green-600',
        percentage: 'white',
        promotionalPrice: 'white',
        priceLabel: 'white',
        stripTitle: 'white',
        priceSuffix: 'white',
        dfpPrice: 'white',
        infoButton: 'white',
        installments: 'white',
      };
    }

    return {
      toPrice: 'critical-600',
      percentage: 'white',
      promotionalPrice: 'neutral-900',
      priceLabel: 'neutral-700',
      stripTitle: 'white',
      priceSuffix: 'neutral-900',
    };
  }

  return {
    toPrice: 'neutral-900',
    priceLabel: 'neutral-700',
    priceSuffix: 'neutral-900',
  };
}

export function getPriceSuffix(unit: string) {
  if (!unit || unit === 'cada') {
    return null;
  }

  return `/${unit}`;
}

export function getPromotionalPrice(price: Price) {
  // must be defined in this order: suggested -> from -> regionPrice
  return (
    [price.suggested, price.from, price.regionPrice].find(
      (price) => price && price > 0
    ) ?? 0
  );
}
